import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initial: 'L',
  name: 'Lucas M.',
  location: 'Buenos Aires',
  role: 'Estudiante de 6to año · UBA',
  quote: 'Estudié el tomo de ECG en un fin de semana y en mi primera guardia reconocí una FA con respuesta ventricular rápida. Mi residente no lo podía creer. Este atlas cambia todo.',
  color: 'bg-blue-500'
}, {
  initial: 'S',
  name: 'Sofía R.',
  location: 'Rosario',
  role: 'Interna rotante · UNR',
  quote: 'Los casos clínicos resueltos son oro. Antes memorizaba sin entender. Ahora razona como médico de verdad. Los diagramas visuales hacen que todo quede grabado.',
  color: 'bg-purple-500'
}, {
  initial: 'V',
  name: 'Valentín F.',
  location: 'Córdoba',
  role: 'Estudiante de medicina · UNC',
  quote: 'Entré a mi primera guardia con el cheatsheet de ECG plastificado en el bolsillo. Reconocí un IAMCEST inferior que se presentó como epigastralgia. Nunca me hubiera dado cuenta sin esto.',
  color: 'bg-green-500'
}, {
  initial: 'C',
  name: 'Camila P.',
  location: 'La Plata',
  role: 'Rotante de clínica médica · UNLP',
  quote: 'Las tablas de drogas del tomo de shock me salvaron en guardia. En 30 segundos tenía la dosis de noradrenalina. El residente me preguntó dónde había estudiado tan bien.',
  color: 'bg-red-500'
}, {
  initial: 'M',
  name: 'Martín D.',
  location: 'Mendoza',
  role: 'Estudiante avanzado · UNCuyo',
  quote: 'El tomo de neurología tiene todo lo que la facultad no te enseña en forma práctica. Ahora entiendo el ACV, la meningitis y el estado epiléptico como situaciones reales, no como textos.',
  color: 'bg-indigo-500'
}, {
  initial: 'A',
  name: 'Agustina B.',
  location: 'Tucumán',
  role: 'Interna · UNT',
  quote: 'Soy de primer año de internado y me sentía perdida en guardia. Este atlas me dio la estructura que ningún libro me dio. Hoy los residentes me preguntan cómo sé tanto.',
  color: 'bg-pink-500'
}, {
  initial: 'F',
  name: 'Federico T.',
  location: 'Mar del Plata',
  role: 'Rotante de guardia · UNMDP',
  quote: 'El tomo de laboratorio crítico es el más útil. Antes veía los resultados y no sabía qué hacer con ellos. Ahora interpreto la gasometría, el ionograma y el lactato en segundos.',
  color: 'bg-teal-500'
}];
export function Testimonials() {
  return <section className="py-16 bg-gray-50 px-4" data-id="element-353">
      <div className="max-w-6xl mx-auto" data-id="element-354">
        <div className="text-center mb-10" data-id="element-355">
          <div className="inline-flex items-center gap-2 bg-accent-gold/20 text-accent-gold font-bold px-4 py-1.5 rounded-full text-xs mb-4 tracking-widest" data-id="element-356">
            <Star size={12} fill="currentColor" data-id="element-357" />
            +500 ESTUDIANTES LO USAN
            <Star size={12} fill="currentColor" data-id="element-358" />
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-gray-900 mb-3" data-id="element-359">
            Lo que dicen los estudiantes
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2" data-id="element-360">
            {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-accent-gold" fill="currentColor" data-id="element-361" />)}
            <span className="ml-2 font-bold text-gray-900" data-id="element-362">4.9/5</span>
          </div>
        </div>

        <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-4 pb-6 md:grid md:grid-cols-2 lg:grid-cols-3 md:overflow-visible md:pb-0" data-id="element-363">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.05
        }} className="min-w-[300px] w-[85vw] md:w-auto md:min-w-0 snap-center bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col h-full relative" data-id="element-364">
              <Quote size={40} className="absolute top-4 right-4 text-gray-100" data-id="element-365" />

              <div className="flex text-accent-gold mb-3 relative" data-id="element-366">
                {[...Array(5)].map((_, idx) => <Star key={idx} size={16} fill="currentColor" data-id="element-367" />)}
              </div>

              <p className="text-gray-700 italic mb-6 flex-grow text-sm md:text-base relative leading-relaxed" data-id="element-368">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100" data-id="element-369">
                <div className={`w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-lg ${t.color} shadow-md ring-2 ring-white`} data-id="element-370">
                  {t.initial}
                </div>
                <div className="flex-1 min-w-0" data-id="element-371">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-372">
                    {t.name} — {t.location}
                  </p>
                  <p className="text-xs text-gray-500 truncate" data-id="element-373">{t.role}</p>
                </div>
                <div className="bg-success-green/10 text-success-green text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-374">
                  ✓ Verificado
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}